import {Edge} from './Edge';

declare const THREE: any;

export class FloorHull extends (THREE.Object3D as { new(): any; }) {

  constructor(points: Array<any>) {
    super();
    for (let i = 0; i < points.length; i++) {
      const firstPoint = points[i];
      const secondPoint = points[(i + 1) % points.length];
      const edge = new Edge(firstPoint, secondPoint);
      this.add(edge);
    }
  }

  movePoint(index: number, newPosition) {
    const children = this.children;
    const childrenCount = children.length;
    const current = children[index] as Edge;
    const nextIndex = index + 1 >= childrenCount ? 0 : index + 1;
    const prevIndex = index - 1 < 0 ? childrenCount - 1 : index - 1;
    const next = children[nextIndex] as Edge;
    const prev = children[prevIndex] as Edge;
    current.position.copy(newPosition);
    current.update(newPosition, next.position);
    prev.update(prev.position, newPosition);
  }

  middlePoints(): any[] {
    return this.children.map(ch => {
      const edge = ch as Edge;
      return edge.center();
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/custom/FloorHull/index.ts